var _mask, _path, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2_24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8912 23.6176C34.8912 33.2525 27.0806 41.0632 17.4456 41.0632C7.81067 41.0632 0 33.2525 0 23.6176C0 13.9826 7.81067 6.17194 17.4456 6.17194C27.0806 6.17194 34.8912 13.9826 34.8912 23.6176ZM2.55847 23.6176C2.55847 31.8395 9.22368 38.5047 17.4456 38.5047C25.6676 38.5047 32.3328 31.8395 32.3328 23.6176C32.3328 15.3956 25.6676 8.73041 17.4456 8.73041C9.22368 8.73041 2.55847 15.3956 2.55847 23.6176Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8912 23.6176C34.8912 33.2525 27.0806 41.0632 17.4456 41.0632C7.81067 41.0632 0 33.2525 0 23.6176C0 13.9826 7.81067 6.17194 17.4456 6.17194C27.0806 6.17194 34.8912 13.9826 34.8912 23.6176ZM2.55847 23.6176C2.55847 31.8395 9.22368 38.5047 17.4456 38.5047C25.6676 38.5047 32.3328 31.8395 32.3328 23.6176C32.3328 15.3956 25.6676 8.73041 17.4456 8.73041C9.22368 8.73041 2.55847 15.3956 2.55847 23.6176Z",
    fill: "#0033A0",
    stroke: "#0033A0",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_2_24)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 41,
    height: 41,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_24",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_24",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACEUlEQVR4nO3bu0oDQRTG8aOIl8K3mGrLnUZs8mimU0EE7QRhpk5pEe18GtMJIoplZDYqIsasm5PJ7Mz/BwuBhMPMl73MJREBAAAAAAAAAAAAAAAAUmMudsT6M6n9o1j3ItZfycFor1Od2p2IdROx/qF5XY22V9Lm3jFNOGOxfvrjuFKpE8Iunpkb8lRq/6zwZYXjoeyczZ/hhONJqU7BQZuF4YRL/lyljvXHUiTTKuRx87ll61h/u7BOlqrRtlh/83c47k4GbjdKnSxVhLx6hBwBIUdAyBEQcgSEHAEhE3IeKsbJhLzY0abIdENSZiKuXYT3VafVh9f7Yp2X2r+J9a9S+8tOiyPhcq796WzHwU2aRXDNRZZehxyEkLs0+KdmW+eXFa2BQoN7H3K4XczO5G4N/y4ses9bPhws0fD+hxwcbX5sUHbvwKfZJqVuB0wWIX8I9+RlOxKE3QXNjpicQk61QybBNmU3AagSastKpNDBKoE2RLHOjlalhKzd0OofdYoLeV0PozrHB19bUc8yX9iZnFzYroCQ1x62KyjktYXtCgz5E5ORiJiMRMRkJNFxtlEYkw/ut/o7Tl5WrMmIdcPWdbILOdZkxLqh2lCw91Y1GbGErBC2I+TO2v3PY9rqwadRp+wz27W7l2rVydrckNz/wtGqU8D/rY+/frUUXne5zLXqAAAAAAAAAAAAAAAkW+/0mAg0ILlzfAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/companyLogo.4e7961aeb3ad35b753ded7cf504dfc4b.svg";
export { ForwardRef as ReactComponent };